/* eslint-disable */
const CNPJ_ALFANUMERICO = /^[A-Z0-9]{12}[0-9]{2}$/;
const CNPJ_NUMERICO_REPETIDO = /^(\d)\1{13}$/;
const PESOS_PRIMEIRO_DV = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const PESOS_SEGUNDO_DV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

export const geraMascaraCNPJ = (pcnpj) => {
  let cnpj = tiraMascaraCNPJ(pcnpj).replace(
    /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([0-9]{2})/,
    '$1.$2.$3/$4-$5'
  );
  return cnpj;
};

export const tiraMascaraCNPJ = (pcnpj) => {
  try {
    return String(pcnpj).toUpperCase().replace(/[^A-Z0-9]/g, '');
  } catch {
    return '';
  }
};

export const validaCNPJ = (cnpj) => {
  const strCNPJ = tiraMascaraCNPJ(cnpj);

  if (!CNPJ_ALFANUMERICO.test(strCNPJ) || CNPJ_NUMERICO_REPETIDO.test(strCNPJ)) {
    return false;
  }

  const base = strCNPJ.substring(0, 12);
  const primeiroDV = calculaDigitoVerificador(base, PESOS_PRIMEIRO_DV);
  const segundoDV = calculaDigitoVerificador(base + primeiroDV, PESOS_SEGUNDO_DV);

  return strCNPJ.substring(12) === `${primeiroDV}${segundoDV}`;
};

function calculaDigitoVerificador(cnpjParcial, pesos) {
  const soma = cnpjParcial
    .split('')
    .reduce((total, caractere, index) => total + (caractere.charCodeAt(0) - 48) * pesos[index], 0);

  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}
